import { ServicePricing } from '@/components/services/ServicePricing'
import { serviceOffers } from '@/data/pricing'

export const ServicesPricing = () => (
  <ServicePricing
    title="Care that fits"
    accent="your next step"
    description="Explore individual appointments and ongoing support, with clear pricing to help you choose."
    offers={Object.values(serviceOffers)}
    showDetails
  />
)
